import { authorizedRDRequests } from "../httpRequest";

const preCartApiRequest = {
    getPreCartDataForBookingModify: (requestData: any) => authorizedRDRequests.post(`webaccessfacility/load/precartdataforbookingmodify`, requestData),
    submitPreCartDataForBookingModify: (requestData: any) => authorizedRDRequests.post(`webaccessfacility/submit/precartdataforbookingmodify`, requestData),
    removeLockforBooking: (requestData: any) => authorizedRDRequests.post(`webaccessfacility/remove/lockforbooking`, requestData),
    removeLockforTimeBaseBooking: (requestData: any) => authorizedRDRequests.post(`webaccessfacility/remove/lockfortimebasebooking`, requestData)
}

export default preCartApiRequest;